import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <h1>Welcome to Shigar Inc</h1>
          <p>Your trusted IT consulting partner in the UK, delivering sustainable success and measurable results for top executives.</p>
          <div className="hero-buttons">
            <Link to="/contact" className="btn">Get Started</Link>
            <Link to="/contact" className="btn btn-outline">Learn More</Link>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="section section-light">
        <div className="container">
          <div className="section-title">
            <h2>About Shigar Inc</h2>
            <p>Shigar is a growing IT consulting firm in the UK. We work with the top executives to achieve sustainable success and to produce realistic, enduring, and measurable results.</p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="section section-gray">
        <div className="container">
          <div className="section-title">
            <h2>Our Services</h2>
            <p>Shigar understands that to help meet client challenges and opportunities successfully in a global economy, you must have a full arsenal of capabilities and experience available at a short notice.</p>
          </div>
          
          <div className="services-intro">
            <p>Within the key areas of Telecommunications and Information Technology, our professionals are skilled at delivering powerful solutions in the following service areas:</p>
            <p>We provide methodologically sophisticated yet practical advice that helps executives significantly improve companies' returns on R&D and marketing investments. We make sure that we generate client buy-in to the solutions that we develop with client teams. To ensure successful implementation, we offer formal training on R&D management tools and processes through Shigar Academy.</p>
          </div>

          <div className="grid grid-2">
            <div className="card">
              <div className="card-icon">
                <span>💼</span>
              </div>
              <h3>Consulting</h3>
              <p>Telecom, SAP, ERP & Digital Marketing</p>
              <p>We work across a range of sectors for many different clients, including multinationals and household names. We help them address challenges across the full business change lifecycle, from strategy through to delivery, and operate at all levels across our clients' organizations.</p>
            </div>
            
            <div className="card">
              <div className="card-icon">
                <span>📱</span>
              </div>
              <h3>Mobile Applications</h3>
              <p>Android & iOS</p>
              <p>We provide whatever level of support our clients need, whether that's being on the ground for an extended period, help through a critical phase of work or simply some short, sharp advice.</p>
              {/* <div className="card-cta">
                <Link to="/whatsapp-signup" className="btn btn-secondary">Get Started with WhatsApp</Link>
              </div> */}
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="section section-light">
        <div className="container">
          <div className="section-title">
            <h2>Our Products</h2>
          </div>
          
          <div className="products-content">
            <div className="product-card">
              <div className="product-icon">
                <span>🛒</span>
              </div>
              <h3>EPOS - Point of Sale Software</h3>
              <p>Point of Sale Software for Restaurants & Cafes</p>
              <p>Our comprehensive EPOS solution is designed specifically for restaurants and cafes, providing seamless transaction management, inventory tracking, and customer relationship management.</p>
            </div>
            
            <div className="product-card">
              <div className="product-icon">
                <span>💬</span>
              </div>
              <h3>WhatsApp Business Platform</h3>
              <p>Complete Business Messaging Solution</p>
              <p>WhatsApp Business messaging platform that enables businesses to manage customer conversations, send broadcast campaigns, and provide customer support through WhatsApp. The application serves as a complete business messaging solution with both automated bot responses and human agent handover capabilities.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="section section-accent">
        <div className="container">
          <div className="section-title">
            <h2>Our Team</h2>
            <p>Our Consultants are Talented and Ambitious</p>
          </div>
          
          <div className="team-content">
            <p>Our experienced consultants can give your organization assistance with your strategic questions.</p>
            <p>We view your problems from a new perspective. We have great and unique business ideas. Our consultants are driven by the opportunity to work on challenging problems.</p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section section-light">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Transform Your Business?</h2>
            <p>Let our experienced consultants help you achieve sustainable success with realistic, enduring, and measurable results.</p>
            <Link to="/contact" className="btn btn-primary">Contact Us Today</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
